import { Component } from '@angular/core';
import { DataLayerBaseComponent } from './data-layer-base.component';
import { DataLayerGeojsonPointComponent } from './data-layer-geojson-point.component';
import { MapService } from './map.service';
import { DataLayerService } from './data-layer.service';
import { ConfigService } from './config.service';
import { UserMessageService } from './user-message.service';

declare var L;

/*
 * data-layer-geojson-cameras defines a class to display cameras.  The data format is geojson.
 *
 * Example of the data file:
 * --------------------------------
 * {
 *	"type": "FeatureCollection",
 *	"features": [
 *	  {
 *		"type": "Feature",
 *		"properties": {
 *			"data_source": "WETMap",
 *			"name": "WET Office",
 *			"link": "http://www.wunderground.com/webcams/WETInc/2/show.html",
 *			"image": "http://cameraftpapi.drivehq.com/api/Camera/GetCameraThumbnail.ashx?parentID=237442473&shareID=13862329",
 *			"image_height": 360,
 *			"image_width": 640
 *		},
 *		"geometry": {
 *		  "type": "Point",
 *		  "coordinates": [-105.07477, 40.603510]
 *		}
 *	  },
 *	  ...
 *	]
 * }
 * --------------------------------
 *
 * Within the configuration file, camera stations can be included:
 * "overlayLayers": [
 * 		{"id": "cameraLayer", "label": "Cameras", "url": "map/overlay-layers/cameraStations.geojson",
 *		 "class": "data-layer-cameras", "refresh": true },
 * ...
 * ]
 */

@Component({
	selector: 'data-layer-cameras',
	template: `
		<div class="checkboxDiv"><label class="overlay-layer"><input type="checkbox" (click)="menuControlSelected($event)">{{htmlElementLabel}}</label>
		<app-single-legend [active]=active [legendUrl]=legendUrl></app-single-legend>
		</div>

		`,
	styleUrls: ['app.component.css']
})
export class DataLayerGeojsonCamerasComponent extends DataLayerGeojsonPointComponent {

	constructor (
		mapService: MapService,
		dataLayerService: DataLayerService,
		configService: ConfigService,
		userMessageService: UserMessageService ) {

		super (mapService, dataLayerService, configService, userMessageService );
		this.htmlElementLabel = 'Cameras';
	}

	onEachPointFeature(feature, layer) {
		// console.log(feature);
		const stationName = 'name';

		const tooltipContent = feature.properties[stationName] + ' (click for more info)';

		layer.on('click', this['contents'].showImages, this);
		layer.bindTooltip(tooltipContent);
	}

	placeMarkers(feature, latlng) {
		let marker;

		marker = L.icon ({
			iconUrl: 'assets/images/camera.png',
			popupAnchor: [0, -40],
			iconSize: [24, 24]
		});

		return L.marker(latlng, {icon: marker});
		// http://stackoverflow.com/questions/29080194/leaflet-adding-an-offset-to-marker
	}

	// Based on the location of the marker,
	// find all associated camera images.
	showImages(e) {
		console.log(e.latlng);
		// console.log(this['contents']);

		const self = this['contents'];

		const cameraFeatures = 
			self.value.features.filter((im: any) => {
			return ( 
				im.geometry.coordinates[0] == e.latlng.lng &&
				im.geometry.coordinates[1] == e.latlng.lat );
		});

		const images = [];
		for ( let i = 0; i < cameraFeatures.length; i++ ) {
			images.push( cameraFeatures[i]['properties']);
		}

		self.mapService.images = images;
		self.mapService.doDisplayImages(images);
		// console.log(self.mapService.images);

	}


}
